import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router'
import { fetchMeWithToken } from '@/api/auth'
import { useAuthStore } from '@/store/auth'
import { useSyncStore } from '@/store/sync'
import { Logo } from '@/components/ui/Logo'

export default function AuthCallbackPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const setUser = useAuthStore((s) => s.setUser)
  const setSyncing = useSyncStore((s) => s.setSyncing)

  useEffect(() => {
    const token = searchParams.get('token')
    const refreshToken = searchParams.get('refresh_token')
    if (!token || !refreshToken) {
      navigate('/login', { replace: true })
      return
    }

    fetchMeWithToken(token)
      .then((profile) => {
        setUser({ ...profile, token, refreshToken })
        if (searchParams.get('is_bootstrapping') === 'true') {
          setSyncing(true)
        }
        navigate('/', { replace: true })
      })
      .catch(() => {
        navigate('/login', { replace: true })
      })
  }, [])

  return (
    <div className="cg-login-page">
      <div className="cg-login-card">
        <div className="cg-brand" style={{ justifyContent: 'center', marginBottom: 16 }}>
          <Logo size={32} />
          <span style={{ fontSize: 20, fontWeight: 600 }}>Common Ground</span>
        </div>
        <p style={{ color: 'var(--fg-2)', textAlign: 'center' }}>Signing you in…</p>
      </div>
    </div>
  )
}
